import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;

export const OPCOES_COMBO = [
  {
    key: 'E',
    label: 'Entrada'
  },
  {
    key: 'S',
    label: 'Saída'
  },
]

export default class PlanoContaForm extends Component {
  state = {
    registro: {
      pc_idf: '',
      pc_codigo: '',
      pc_descricao: '',
      pc_tipo: { key: 'S' },
      pc_abreviatura: '',
      pc_conta: '',
      pc_conta_aux: '',
      pc_receb_lcto: '0',
      pc_cta_operacional: '0',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {
        this.refs.pc_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.pc_descricao) || (this.state.registro.pc_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.pc_conta) || (this.state.registro.pc_conta === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nível da Conta' });
      return;
    }
    if ((!this.state.registro.pc_abreviatura) || (this.state.registro.pc_abreviatura === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Abreviatura' });
      return;
    }

    this.state.registro.pc_tipo = this.state.registro.pc_tipo.key;

    let nivel = this.state.registro.pc_conta;
    let nivelAux = '';
    let str = '0123456789.';
    for (var i = 0; i < nivel.length; i++) {
      if (str.indexOf(nivel.substring(i, i + 1)) >= 0) {
        nivelAux = nivelAux + nivel.substring(i, i + 1);
      }
    }
    let arrayStr = nivelAux.split(".");
    nivelAux = '';
    for (var i = 0; i < arrayStr.length; i++) {
      nivelAux = nivelAux + ('0000' + arrayStr[i]).substring((4 + arrayStr[i].length) - 4, 4 + arrayStr[i].length);
    }
    this.state.registro.pc_conta_aux = nivelAux;

    this.props.onSalvarClick(this.state.registro);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { pc_idf, pc_codigo, pc_tipo, pc_abreviatura, pc_conta, pc_receb_lcto,
      pc_cta_operacional, pc_descricao } = this.state.registro;

    return (
      <Modal
        title={pc_idf ? "Edição de Plano de Conta" : "Cadastro de Plano de Conta"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"50%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>Descrição *</span>
              <InputForm
                id="pc_descricao"
                ref="pc_descricao"
                maxLength={50}
                onChange={this.onChange}
                value={pc_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
            <Col xs={24} sm={4} style={{ marginTop: -20 }}>
              <span>Código</span>
              <InputForm
                id="pc_codigo"
                ref="pc_codigo"
                maxLength={10}
                onChange={this.onChange}
                value={pc_codigo}
                disabled={true}
              />
            </Col>
            <Col xs={0} sm={1} />
            <Col xs={24} sm={14} style={{ marginTop: -20 }}>
              <span>Nível da Conta *</span>
              <InputForm
                id="pc_conta"
                ref="pc_conta"
                maxLength={40}
                onChange={this.onChange}
                value={pc_conta}
                validator={value => Boolean(value)}
              />
            </Col>
            <Col xs={0} sm={1} />
            <Col xs={24} sm={4} style={{ marginTop: -20 }}>
              <span>Abreviatura *</span>
              <InputForm
                id="pc_abreviatura"
                ref="pc_abreviatura"
                maxLength={5}
                onChange={this.onChange}
                value={pc_abreviatura}
                validator={value => Boolean(value)}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20 }}>
              <span>Tipo de Conta</span>
              <InputForm
                type="select"
                id="pc_tipo"
                ref="pc_tipo"
                value={pc_tipo}
                placeholder="Selecione o Tipo"
                onChange={this.onChange}
                data={OPCOES_COMBO}
                validator={value => Boolean(value)}
              />
            </Col>
            <Col xs={0} sm={1} />
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="pc_receb_lcto"
                ref="pc_receb_lcto"
                onChange={this.onChange}
                value={pc_receb_lcto}
              >
                Recebe Lançamento
              </InputForm>
            </Col>
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="pc_cta_operacional"
                ref="pc_cta_operacional"
                onChange={this.onChange}
                value={pc_cta_operacional}
              >
                Conta Operacional
              </InputForm>
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PlanoContaForm.js